import { selectActiveWorkspaceId } from "@somewear/auth";
import { grpc, someGrpc } from "@somewear/grpc";
import type { ActionSetEpic } from "@somewear/model";
import { createActionSetEpicHandler } from "@somewear/model";
import { combineEpics } from "redux-observable";
import { map } from "rxjs/operators";

import type { IWorkspaceKey, IWorkspaceToken } from "./workspaceKeysSlice";
import { workspaceKeyActions } from "./workspaceKeysSlice";

const generateWorkspaceKeyEpic: ActionSetEpic<undefined, IWorkspaceKey> = (action$, state$) => {
	return createActionSetEpicHandler(action$, state$, workspaceKeyActions.generateKey, () =>
		grpc.prepareRequest(someGrpc.generateAdditionalWorkspaceKey).pipe(
			map((response) => {
				const workspaceId = selectActiveWorkspaceId(state$.value);
				return {
					id: workspaceId,
					key: response.toObject().key,
				} as IWorkspaceKey;
			}),
		),
	);
};

const generateWorkspaceTokenEpic: ActionSetEpic<undefined, IWorkspaceToken> = (action$, state$) => {
	return createActionSetEpicHandler(action$, state$, workspaceKeyActions.generateToken, () =>
		grpc
			.prepareRequestWithPayload(
				someGrpc.generateWorkspaceToken,
				selectActiveWorkspaceId(state$.value)!,
			)
			.pipe(
				map((response) => {
					return {
						id: response.getWorkspaceName(),
						url: response.getUrl(),
					} as IWorkspaceToken;
				}),
			),
	);
};

export const workspaceKeyEpics = combineEpics(generateWorkspaceKeyEpic, generateWorkspaceTokenEpic);
